export default "__VITE_ASSET__DkJWx$mk__"